import React, { Component, PropTypes } from 'react';
import { CargoType, CategoryType } from 'types';
import ActionCreators from 'actions/ActionCreators';
import GeneralStore from 'stores/GeneralStore';
import EditingCargoStore from 'stores/EditingCargoStore';
import CargoPhotoControl from 'components/CargoPhotoControl';
import IconSVG from 'svg-inline-react';
import { removeCargoPhoto } from 'api';

import './CargoPhotoList.scss';

class CargoPhoto extends Component {

    static propTypes = {
        uriData: PropTypes.string.isRequired,
        index: PropTypes.number.isRequired,
        onDelete: PropTypes.func
    };

    constructor(props) {
        super(props);
    };

    state = {
        transformAngle: 0
    };

    handlerDelete = (e) => {
        e.stopPropagation();
        if (this.props.onDelete) this.props.onDelete(this.props.index);
    };

    handlerRotate = () => {
        this.setState((prevState) => {
            return {transformAngle: prevState.transformAngle + 90};
        });
    }

    _renderDeleteButton = () => {
        if (!GeneralStore.isEditMode()) {
            return (
                <div className="Photo-delete" onClick={ this.handlerDelete }><IconSVG src={require('!svg-inline!./del_photo_icon.svg')}/></div>
            )
        }
    }

    render() {
        return (
            <div className="Photo">
                {this._renderDeleteButton()}
                <img src={ this.props.uriData } style={{transform: `rotate(${this.state.transformAngle}deg)`}}/>
            </div>
        );
    };
}

class CargoPhotoList extends Component {

    static propTypes = {
        photo: PropTypes.array
    };

    constructor(props) {
        super(props);
    };

    renderPhoto = (uriData, i) => {
        return <CargoPhoto key={ i.toString() } uriData={ uriData } index={ i } onDelete={ this.handlerPhotoDelete } />;
    }

    render() {
        var photos = '';
        var addPhoto = this.props.photo.length < 4 ? <CargoPhotoControl cargo={ this.props.cargo }/> : ''; // max 4 photos for Cargo
        if (this.props.photo && this.props.photo.length > 0) {
            photos = this.props.photo.map(this.renderPhoto);
        }

        return (
            <div>
                <div className="CargoPhotoList">
                    { photos }
                    { addPhoto }
                </div>
                <div>Осталось фотографий для загрузки: <b>{4 - this.props.photo.length}</b></div>
            </div>
        );
    };

    handlerPhotoDelete = (index) => {

        let request = {};
        request.index = index;

        removeCargoPhoto(request).then((result) => {

            var photo = EditingCargoStore.getEditingCargo().getIn(['attributes', 'photo', 'value']);
            if (!photo) photo = [];
            var list = [];

            for (var i = 0; i < photo.length; i++) list.push(photo[i]);
            if (index < 0 || index >= list.length) return;
            list.splice(index, 1);
            ActionCreators.updateEditingCargo({
                'photo': ( list.length == 0 ? undefined : list )
            });

        });
    };
}

export default CargoPhotoList;



// WEBPACK FOOTER //
// ./client/components/CargoPhotoList/CargoPhotoList.js